import request from '@/utils/axios'
import { ContentTypeEnum } from '@/enums/axios'

const jsonHeaderConfig = {
  headers: {
    'Content-Type': ContentTypeEnum.JSON
  }
}

// 回收站列表
export const getRecycleBin = (data?: any) => request.post('/crm/crud/page', data, jsonHeaderConfig)

// 回收站列表-还原到客户或公海池
export const restoreRecycleBin = (data?: any) =>
  request.post('/crm/track/recycle/restore', data, jsonHeaderConfig)

// 回收站列表-删除
export const deleteRecycleBin = (data?: any) => request.post('/crm/track/recycle/del', data)

// 回收站列表-操作人列表
export const getOptions = (data?: any) => request.get('/crm/track/recycle/all/user', data)

// 回收站-客户详情
export const getDetail = (data: any, options: any) =>
  request.get('/crm/track/recycle/getOrderInfoById', data, options)
